/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LastEvaluationStatusesViewModel } from './LastEvaluationStatusesViewModel'; 

export function getEvaluationStatusesOptions(certificationPeriodId: string, onSuccess?: (result: LastEvaluationStatusesViewModel) => void) {
	return queryOptions({
		queryKey: ['evaluation-statuses', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getevaluationstatuses/' + certificationPeriodId;
			const resp = await axios.get<LastEvaluationStatusesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}